import { render } from "./CompanyOrganization.vue?vue&type=template&id=b888f9c0&scoped=true"
import script from "./CompanyOrganization.vue?vue&type=script&lang=js"
export * from "./CompanyOrganization.vue?vue&type=script&lang=js"

import "./CompanyOrganization.vue?vue&type=style&index=0&id=b888f9c0&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b888f9c0"]])

export default __exports__